import React, { useCallback } from 'react';
import Text from 'components/Text';
const Button = (props) => {
    const handleClick = useCallback(() => (!props.disabled ? props.onClick() : undefined), [props]);
    return (React.createElement("div", { className: `button ${props.disabled ? 'disabled' : ''}`, onClick: handleClick, "data-testid": "button" },
        React.createElement(Text.Button, null, props.children)));
};
export default Button;
